var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "downloadMppModal",
    attrs: { id: "download-mpp-modal", "modal-dialog-size": "lg" },
    on: { show: _vm.handleShow },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("direct-to-lender.lenderResponse.downloadMPP")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _c("b-col", [
                  _c("div", { staticClass: "px-2" }, [
                    _c("h6", { staticClass: "text-grey font-sm bold mb-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "direct-to-lender.lenderResponse.requestsMPP"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-client-table", {
              ref: "mppRequestsTable",
              staticClass: "vue-custom-table no-pagination",
              attrs: {
                data: _vm.currentMppAppInfo,
                columns: _vm.requestsTable.columns,
                options: _vm.requestsTable.options,
              },
              scopedSlots: _vm._u([
                {
                  key: "name",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(row.firstName) +
                          " " +
                          _vm._s(row.lastName) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "status",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "mb-0 font-sm text-light-gray bold d-inline",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(row.status || "Unknown") +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "onlineApplicationLink",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      row.onlineApplicationLink
                        ? _c(
                            "a",
                            {
                              staticClass: "text-primary bold",
                              attrs: {
                                href: row.onlineApplicationLink,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("truncateText")(
                                      row.onlineApplicationLink,
                                      30
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c("span", [
                            _vm._v(_vm._s(_vm.$t("global.messages.na"))),
                          ]),
                    ]
                  },
                },
                {
                  key: "viewDetails",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "button",
                        {
                          staticClass: "btn-sm btn btn-primary",
                          on: {
                            click: function ($event) {
                              return _vm.viewMppDetails(row, $event)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("global.actions.viewDetails")) +
                              "\n          "
                          ),
                          _c("icon", {
                            staticClass: "ml-2",
                            attrs: { name: "caret-down" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "child_row",
                  fn: function (props) {
                    return [
                      _c(
                        "b-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _c("b-col", [
                            _c("p", [
                              _c("span", { staticClass: "bold mr-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderResponse.eligibleForDisabilityInsurance"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("booleanYesNo")(
                                      _vm.getDisabilityInsuranceElegible(
                                        props.row
                                      )
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("span", { staticClass: "bold mr-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderResponse.eligibleForLifeInsurance"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("booleanYesNo")(
                                      _vm.getLifeInsuranceElegible(props.row)
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "m-0" }, [
                              _c("span", { staticClass: "bold mr-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderResponse.applicationKey"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.row.applicationKey) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-col", [
                            _c("p", [
                              _c("span", { staticClass: "bold mr-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderResponse.disabilityInsurancePremium"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.getDisabilityInsurance(props.row)
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _c("span", { staticClass: "bold mr-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderResponse.lifeInsurancePremium"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getLifeInsurance(props.row)) +
                                  "\n            "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "m-0" }, [
                              _c("span", { staticClass: "bold mr-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "direct-to-lender.lenderResponse.premiumPaymentFrequency"
                                    )
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    props.row.applicationQuotePremium[0]
                                      .premiumPaymentFrequency
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _c("b-col", [
                  _c("div", { staticClass: "px-2" }, [
                    _c("h6", { staticClass: "text-grey font-sm bold mb-1" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "direct-to-lender.lenderResponse.documentsMPP"
                            )
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("v-client-table", {
              ref: "mppDocumentsTable",
              staticClass: "vue-custom-table no-pagination",
              attrs: {
                data: _vm.currentMppDocuments,
                columns: _vm.documentsTable.columns,
                options: _vm.documentsTable.options,
              },
              scopedSlots: _vm._u([
                {
                  key: "selected",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "form-group-checkbox" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pretty p-icon p-jelly p-smooth p-curve mr-0",
                          },
                          [
                            _c("input", {
                              staticClass: "checkbox select-mpp-doc",
                              attrs: {
                                type: "checkbox",
                                "true-value": "true",
                                name: "select-mpp-" + row.fileName,
                              },
                              domProps: {
                                checked: _vm.mppDocIsSelected(row.fileName),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleSelectMppDoc(
                                    row.fileName,
                                    row.s3Key
                                  )
                                },
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "state p-success" },
                              [
                                _c("icon", {
                                  staticClass: "icon",
                                  attrs: { name: "check" },
                                }),
                                _vm._v(" "),
                                _c("label", {
                                  attrs: { for: "select-mpp-" + row.fileName },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: "document",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("truncateFileName")(row.fileName, 35)) +
                          "\n      "
                      ),
                    ]
                  },
                },
                {
                  key: "applicant",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v("\n        " + _vm._s(row.applicant) + "\n      "),
                    ]
                  },
                },
                {
                  key: "actions",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-inline-flex flex-row align-items-center justify-content-end w-100",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.handlePreviewMppDocument({
                                    fileName: row.fileName,
                                    s3Key: row.s3Key,
                                  })
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.words.preview")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isDocLoading(row.s3Key) || _vm.previewingMpp
                            ? _c("inline-loader", {
                                staticClass: "px-4",
                                attrs: { width: "20px", height: "20px" },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "primary btn-sm",
                  loading: _vm.downloadingMpp.loading,
                  "loading-status": _vm.downloadingMpp.status,
                  disabled: !_vm.documentsSelected,
                  "class-name": "download-mpp",
                },
                on: { click: _vm.handleDownloadDocument },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.words.download")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }